import { apiSlice } from "fond/api/apiSlice";
import { ListCustomOverlaysResponse } from "fond/types/overlays";

/**
 * Custom Overlays API Slice
 */
export const overlaysSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getOverlays: build.query<ListCustomOverlaysResponse, { versionId: string } | { multiProjectId: string }>({
      query: (params) => ({
        url: `/v2/custom-overlays`,
        method: "GET",
        params: "versionId" in params ? { version_id: params.versionId } : { multi_project_id: params.multiProjectId },
      }),
      providesTags: (_result, _error, params) => {
        const id = "versionId" in params ? params.versionId : params.multiProjectId;
        return [{ type: "Overlay", id }];
      },
    }),
    createOverlay: build.mutation<void, { name: string; sourceVersionId: string; targetType: "VERSION" | "MULTI_PROJECT"; targetId: string }>({
      query: ({ name, sourceVersionId, targetType, targetId }) => ({
        url: `/v2/custom-overlays`,
        method: "POST",
        body: {
          name,
          source_version: {
            id: sourceVersionId,
          },
          target: {
            type: targetType === "VERSION" ? "version" : "multi_project",
            id: targetId,
          },
        },
      }),
      invalidatesTags: (_result, _error, { targetId }) => {
        return [{ type: "Overlay", id: targetId }];
      },
    }),
    updateOverlay: build.mutation<void, { overlayId: string; name: string; versionId?: string; multiProjectId?: string }>({
      query: ({ overlayId, name }) => ({
        url: `/v2/custom-overlays/${overlayId}`,
        method: "PATCH",
        body: { Name: name },
      }),
      invalidatesTags: (_result, _error, { versionId, multiProjectId }) => {
        const id = versionId || multiProjectId;
        return [{ type: "Overlay", id }];
      },
    }),
    deleteOverlay: build.mutation<void, { overlayId: string } & ({ versionId: string } | { multiProjectId: string })>({
      query: ({ overlayId }) => ({
        url: `/v2/custom-overlays/${overlayId}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, params) => {
        const id = "versionId" in params ? params.versionId : params.multiProjectId;
        return [{ type: "Overlay", id }];
      },
    }),
  }),
});

/**
 * Endpoint Hooks
 */
export const { useGetOverlaysQuery, useCreateOverlayMutation, useUpdateOverlayMutation, useDeleteOverlayMutation } = overlaysSlice;
